import React, { useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import LinearProgress from "@material-ui/core/LinearProgress";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Trad } from "../../components/";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    bar: {
        marginTop: spacing(1)
    },
    weak: {
        backgroundColor: palette.error.main
    },
    medium: {
        backgroundColor: palette.warning.main
    },
    strong: {
        backgroundColor: palette.success.main
    }
}));

interface IPasswordFieldProps {
    Disabled?: boolean;
    Value: string;
    OnChange: (e: React.FormEvent<any>) => void;
    HideBar?: boolean;
    Label?: string;
}

export const _PasswordField: React.FC<IPasswordFieldProps> = ({ Disabled, HideBar, Label, OnChange, Value }) => {
    const classes = useStyles();

    const [ShowPassword, setShowPassword] = useState(false);

    const countPasswordStrength = (): number => {
        let points: number = Value.length; //un punto per ogni carattere
        const numRx: RegExp = /[0-9]/; //espressione regolare per i numeri (oppure [:digit:])
        const almRx: RegExp = /[a-z]/; //espressione regolare per le lettere minuscole
        const ALMRx: RegExp = /[A-Z]/; //espressione regolare per le lettere maiuscole
        const poiRx: RegExp = /[.:;,!\"£$%\&\/\(\)\=\?\^\'\ì\[\]@#]/; // espressione regolare per i simboli
        const validRx: RegExp = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

        if (numRx.test(Value)) {
            points = points + 3;
        }
        if (almRx.test(Value)) {
            points = points + 2;
        }
        if (ALMRx.test(Value)) {
            points = points + 3;
        }
        if (poiRx.test(Value)) {
            points = points + 4;
        }
        if (points >= 20 && !validRx.test(Value)) {
            return 39;
        }
        if (points > 50) {
            return 100;
        }

        return points * 2;
    };

    const onClickShowPassword = () => {
        setShowPassword(!ShowPassword);
    };

    const passwordStrength = countPasswordStrength();

    const getBarClassName = (): string => {
        if (passwordStrength < 40) {
            return "weak";
        } else if (passwordStrength < 60) {
            return "medium";
        }
        return "strong";
    };

    return (
        <>
            <TextField
                value={Value}
                id="Password"
                label={Trad.Trad(Label || "Password")}
                onChange={OnChange}
                disabled={Disabled}
                type={ShowPassword ? "text" : "password"}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <Tooltip title={ShowPassword ? Trad.Trad("Hide") : Trad.Trad("Show")}>
                                <IconButton aria-label="toggle password visibility" onClick={onClickShowPassword} onMouseDown={e => e.preventDefault()} size="small">
                                    {ShowPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    ),
                    autoComplete: "new-password"
                }}
                fullWidth
            />
            {!HideBar && (
                <LinearProgress
                    variant="determinate"
                    value={passwordStrength}
                    className={classes.bar}
                    classes={{
                        barColorPrimary: classes[getBarClassName()]
                    }}
                />
            )}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/PasswordField.tsx